import { Pipe, PipeTransform } from '@angular/core';
import { FileService } from '../services/file.service';

@Pipe({
  name: 'fileType'
})
export class FileTypePipe implements PipeTransform {

  transform(value: string): string {
    return FileService.getFileType(value);
  }

}
